import apiFetch from '../apiFetch'

export default function (token, financingTypeProduct) {
  return apiFetch({ endPoint: 'SaleType/Update/', method: 'POST', body: financingTypeProduct, token: token })
}
